import { render, staticRenderFns } from "./couponEmpty.vue?vue&type=template&id=206c9961&scoped=true&"
import script from "./couponEmpty.vue?vue&type=script&lang=js&"
export * from "./couponEmpty.vue?vue&type=script&lang=js&"
import style0 from "./couponEmpty.vue?vue&type=style&index=0&id=206c9961&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206c9961",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIcon: require('/app/components/svgIcon/svgIcon.vue').default})
